import './Client.scss';

import React from 'react';

import ProfilPersonnelClient, { typeEnum } from '../../../Components/shared/ProfilPersonnelClient';
import useWindowSize from '../../../hooks/useWindowSize';
import SideBarMobile from '../../Expert/CompleterProfile/SideBarMobile';
import DrawSideBar from './SideBarClient';

function ClientStep1() {
    const {device}=useWindowSize();

    return (
        <>
            <div style={{display:'flex',flexDirection:device=='desktop' ?'row':'column',alignSelf:'stretch'}}>
                {device=='desktop' &&
                <DrawSideBar />
                }
                {device!='desktop' &&
                    <SideBarMobile
                        etape={'Etape 1'}
                        etapSuivante='Etape 2'
                        number='1'
                    />
                }
                <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between',width:device=='desktop'?'80%':'100%',alignItems: 'center',padding:device=='desktop'?'0px':'16px',paddingTop: '64px'}}>
                    <ProfilPersonnelClient
                        type={typeEnum?.set}
                        titre='Dites-nous plus sur vous!'
                    />
                </div>
            </div>
        </>
    );
}

export default ClientStep1;

